<template>
	<div ref="wrapper" :class="['bs-wrapper-xs', ...breakpoint]">
		<slot />
		<resize-observer @notify="onResize" />
	</div>
</template>
<script>
	import _ from 'lodash'
	import $ from 'jquery'
	import { ResizeObserver } from 'vue3-resize'

	export default {
		components: {
			'resize-observer': ResizeObserver
		},
		emits: ['resize'],
		data() {
			return {
				width: 0
			}
		},
		computed: {
			breakpoint() {
				let arr = []
				if (this.width >= 576) arr.push('bs-wrapper-sm')
				if (this.width >= 768) arr.push('bs-wrapper-md')
				if (this.width >= 992) arr.push('bs-wrapper-lg')
				if (this.width >= 1200) arr.push('bs-wrapper-xl')
				return arr
			},
			currentBreakpoint() {
				if (this.width >= 1200) return 'xl'
				if (this.width >= 992) return 'lg'
				if (this.width >= 768) return 'md'
				if (this.width >= 576) return 'sm'
				return 'xs'
			}
		},
		created() {
			this.onResize = _.throttle(this.onResize, 50)
		},
		mounted() {
			this.$nextTick(() => {
				this.onResize()
			})
		},
		methods: {
			onResize() {
				this.width = parseFloat($(this.$refs.wrapper).width())
				this.$emit('resize', this.width, this.currentBreakpoint)
			}
		}
	}
</script>
<style src="~/styles/bootstrap-wrapper.less" lang="less"></style>
